import React, { OptionHTMLAttributes, SelectHTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import { COLORS, STATIC_COLORS } from '../../theme';
import { formInputFocusStyle } from './Input';

type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
  shouldValidate?: boolean;
  isValid?: boolean;
  needsSpacing?: boolean;
};

const StyledSelect = styled.select<{
  $isValid: boolean;
  $needsSpacing: boolean;
  $shouldValidate: boolean;
}>`
  appearance: none;
  background: ${COLORS.WHITE};
  color: ${COLORS.TEXT};
  border-radius: 8px;
  height: 45px;
  width: 100%;
  font-size: 1rem;
  padding: 0 42px 0 22px;
  border: 1px solid ${COLORS.GRAY_DARKER};

  &:disabled {
    border: 1px solid ${COLORS.GRAY};
    outline: none;
  }

  &:focus-visible,
  &:focus {
    ${formInputFocusStyle};
  }

  ${(props) =>
    !props.$isValid &&
    props.$shouldValidate &&
    css`
      border: 2px solid ${COLORS.ERROR};
      outline: none;
      &:focus-visible,
      &:focus {
        border: 2px solid ${COLORS.ERROR};
      }
    `};

  ${(props) =>
    props.$isValid &&
    props.$shouldValidate &&
    css`
      border: 2px solid ${STATIC_COLORS.BLACK};
      outline: none;
      &:focus-visible,
      &:focus {
        border: 2px solid ${STATIC_COLORS.BLACK};
      }
    `};

  ${(props) =>
    props.$needsSpacing &&
    css`
      padding: 0 30px;
    `};

  background-image: url("data:image/svg+xml,%3Csvg width='15' height='9' viewBox='0 0 15 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.0859384 1.19811C0.0859384 0.899465 0.20027 0.600825 0.427765 0.373345C0.883923 -0.0827822 1.62124 -0.0827822 2.0774 0.373345L7.08579 5.38141L12.0942 0.373345C12.5503 -0.0827818 13.2877 -0.0827818 13.7438 0.373345C14.2 0.829472 14.2 1.56674 13.7438 2.02287L7.91061 7.85569C7.45445 8.31182 6.71713 8.31182 6.26098 7.85569L0.427765 2.02287C0.20027 1.79539 0.0859384 1.49675 0.0859384 1.19811Z' fill='%23282828'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 22px bottom 50%;
`;

type OptionType = React.FC<OptionHTMLAttributes<HTMLOptionElement>>;
const StyledOption = styled.option``;

export const Select: React.FC<SelectProps> & { Option: OptionType } = ({
  isValid = false,
  needsSpacing = false,
  shouldValidate = false,
  ...rest
}) => {
  return (
    <StyledSelect
      $isValid={isValid}
      $shouldValidate={shouldValidate}
      $needsSpacing={needsSpacing}
      {...rest}
    />
  );
};

Select.Option = StyledOption;
